// extracted by mini-css-extract-plugin
export default {"labelDesktopStyle":"TextFieldWidgetTextBig_labelDesktopStyle__nydc4"};